module.exports = __webpack_public_path__ + "static/media/13.7402d69b.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/style/Images/13.JPG
// module id = 455
// module chunks = 0